import React from "react";
import HorizontalScroll from "@Components/HorizontalScroll";
import { ReviewData } from "../../types";
import ReviewCard, { MobileReviewCard } from "../ReviewCard";
import styles from "./reviewCardsList.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface ReviewCardsListProps {
  reviews: ReviewData[];
  onMediaClick?: (index: number) => void;
  onReadMore?: (reviewId: string) => void;
  mediaIndexMap?: Map<string, number>;
  isDesktop?: boolean;
  propertyId?: string | number;
}

const CARD_WIDTH_DESKTOP = 480;

const ReviewCardsList: React.FC<ReviewCardsListProps> = ({
  reviews,
  onMediaClick,
  onReadMore,
  mediaIndexMap,
  isDesktop,
  propertyId,
}) => {
  if (!reviews || reviews.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <HorizontalScroll
        showControls={isDesktop}
        itemSize={CARD_WIDTH_DESKTOP}
        className={styles.scrollContainer}
      >
        {reviews.map((review) => (
          <div key={review.id} className={styles.cardWrapper}>
            {isDesktop ? (
              <ReviewCard
                review={review}
                onMediaClick={onMediaClick}
                onReadMore={onReadMore}
                mediaStartIndex={mediaIndexMap?.get(review.id) || 0}
                propertyId={propertyId}
              />
            ) : (
              <>
                <MobileReviewCard
                  review={review}
                  onMediaClick={onMediaClick}
                  onReadMore={onReadMore}
                  mediaStartIndex={mediaIndexMap?.get(review.id) || 0}
                  propertyId={propertyId}
                />
                <div className={styles.verticalSeparator} />
              </>
            )}
          </div>
        ))}
      </HorizontalScroll>
    </div>
  );
};

export default wrapperHOC(ReviewCardsList, {
  componentName: "ReviewCardsList",
  showForChina: true,
});
